import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-vendor-certification-etraining',
    templateUrl: './vendor-certification-etraining.component.html',
    styleUrls: ['./vendor-certification-etraining.component.scss']
})
export class VendorCertificationEtrainingComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}